// image.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as ImageActions from './image.actions';

export interface ImageState {
  imageUrl: string | null;
  publicId: string | null;

  uploading: boolean;
  generating: boolean;
  deleting: boolean;

  uploadError: any;
  generationError: unknown;
  deleteError: any;
}

export const initialState: ImageState = {
  imageUrl: null,
  publicId: null,
  uploading: false,
  generating: false,
  deleting: false,
  uploadError: null,
  generationError: null,
  deleteError: null,
};

export const imageReducer = createReducer(
  initialState,

  // Upload
  on(ImageActions.uploadImage, (state) => ({
    ...state,
    uploading: true,
    uploadError: null,
  })),
  on(ImageActions.uploadImageSuccess, (state, { imageUrl, publicId }) => ({
    ...state,
    uploading: false,
    imageUrl,
    publicId,
  })),
  on(ImageActions.uploadImageFailure, (state, { error }) => ({
    ...state,
    uploading: false,
    uploadError: error,
  })),

  // AI generation writes the same canonical Cloudinary fields as manual upload.
  on(ImageActions.generateRecipeImage, (state) => ({
    ...state,
    generating: true,
    generationError: null,
  })),
  on(ImageActions.generateRecipeImageSuccess, (state, { imageUrl, publicId }) => ({
    ...state,
    generating: false,
    imageUrl,
    publicId,
  })),
  on(ImageActions.generateRecipeImageFailure, (state, { error }) => ({
    ...state,
    generating: false,
    generationError: error,
  })),

  // Delete
  on(ImageActions.deleteImage, (state) => ({
    ...state,
    deleting: true,
    deleteError: null,
  })),
  on(ImageActions.deleteImageSuccess, (state) => ({
    ...state,
    deleting: false,
    imageUrl: null,
    publicId: null,
  })),
  on(ImageActions.deleteImageFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    deleteError: error,
  })),

  // Reset
  on(ImageActions.resetImageState, () => initialState)
);
